var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1745_602)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0944 9.82506C49.342 5.65932 39.9636 3.21918 31.2474 2.20938C20.5665 0.997618 9.86903 2.11735 0.0330737 5.64142C9.20819 4.39387 18.6223 4.24687 28.0544 4.94479C36.7527 5.58646 45.2491 6.72408 54.0944 9.82634V9.82506Z",
    fill: "url(#paint0_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1034 23.3858C58.8827 17.8447 59.7455 11.4216 59.9666 5.64014C40.6258 -1.71734 19.3739 -1.71734 0.0330737 5.64142C16.512 0.575804 39.1008 1.47568 54.0944 9.82506C53.9666 25.4782 50.7736 40.3427 38.4413 50.7104C49.1579 43.7735 53.6368 34.2315 57.1047 23.3858H57.1034Z",
    fill: "url(#paint1_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1034 23.3858C58.8827 17.8447 59.7455 11.4216 59.9666 5.64014C58.6999 18.926 54.3143 29.9009 48.552 37.7914C46.2039 42.5809 42.9189 46.9486 38.4413 50.7104C49.1579 43.7735 53.6368 34.2315 57.1047 23.3858H57.1034Z",
    fill: "url(#paint2_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9666 5.64142C58.388 26.6529 48.3501 46.6738 29.9998 56.327C50.1677 52.2162 60.2964 31.2597 59.9666 5.64142Z",
    fill: "url(#paint3_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9666 5.64142C59.4898 29.5711 48.552 48.7842 29.9998 56.327C11.4285 46.5639 6.29 30.1208 5.90397 11.0726C5.62915 30.7816 9.75783 51.3713 29.9986 62.8766C54.2402 51.609 60.5163 30.9094 59.9653 5.64014L59.9666 5.64142Z",
    fill: "url(#paint4_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7033 38.3244C7.61041 30.3598 6.10593 21.0747 5.90397 11.0739C5.62915 30.7829 9.75783 51.3726 29.9986 62.8779C22.4021 57.9222 15.0433 49.8489 11.7033 38.3244Z",
    fill: "url(#paint5_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9998 62.8779C11.2265 51.9222 6.07014 30.1399 5.88736 9.82506C0.509853 35.7552 10.3816 53.0956 29.9998 62.8779Z",
    fill: "url(#paint6_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9998 62.8779C11.7774 53.1698 4.23461 35.975 5.88736 9.82506C21.5776 4.74155 38.4042 4.74155 54.0944 9.82506C40.4775 3.32911 17.7225 1.93456 0.0330737 5.64142C-0.516564 30.9107 5.74036 51.6103 29.9998 62.8779Z",
    fill: "url(#paint7_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8085 7.84253C49.2678 8.39344 51.6901 9.05429 54.0932 9.82506C40.4775 3.32911 17.7225 1.93456 0.0330737 5.64142C16.3842 2.7245 34.1656 3.78799 46.8098 7.84381L46.8085 7.84253Z",
    fill: "url(#paint8_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.348 37.5L30.1737 13.5L15 37.5C23.5337 36.5702 30.1743 29.341 30.1743 20.5607C30.1743 29.341 36.8149 36.5702 45.348 37.5Z",
    fill: "url(#paint9_linear_1745_602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1743 20.5623V13.5L15 37.5C23.5331 36.5702 30.1732 29.3421 30.1743 20.5623Z",
    fill: "#19B5FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1745_602",
    x1: 0.17923,
    y1: 31.4978,
    x2: 108.603,
    y2: 31.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1745_602",
    x1: -4.41666,
    y1: 31.5007,
    x2: 76.8809,
    y2: 31.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5998B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1745_602",
    x1: 188.904,
    y1: 31.5018,
    x2: 22.5459,
    y2: 31.5018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1745_602",
    x1: 59.2481,
    y1: 31.4993,
    x2: -60.0479,
    y2: 31.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1745_602",
    x1: 82.7252,
    y1: 31.5014,
    x2: -19.9171,
    y2: 31.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5998B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1745_602",
    x1: 193.54,
    y1: 31.5,
    x2: -12.1747,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0A4F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1745_602",
    x1: 29.9984,
    y1: 62.8779,
    x2: 29.9984,
    y2: -53.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1745_602",
    x1: 29.9989,
    y1: 74.6592,
    x2: 29.9989,
    y2: -27.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#11506E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1745_602",
    x1: -115.842,
    y1: 6.7228,
    x2: 54.1059,
    y2: 6.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1745_602",
    x1: 30.174,
    y1: -39.919,
    x2: 30.174,
    y2: 42.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0A4F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#001925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1745_602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 62.7559,
    fill: "white",
    transform: "translate(0 0.12207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStAppIcon);
export default __webpack_public_path__ + "static/media/st-app-icon.4eb03cb02ba127ff752eedb055f080f7.svg";
export { ForwardRef as ReactComponent };